module.exports = __webpack_public_path__ + "static/media/animal-lion2.3733f801.aac";